import { Dispatcher } from "flux";
import { Action } from "./Actions";

export default new Dispatcher<Action>();
